module.exports = __webpack_public_path__ + "static/conflit-25b4b64be1ab75851fee962148afaf68.mp4";